import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["poster", "video"];

  connect() {
    this.videoTarget.addEventListener("canplay", this.hidePoster.bind(this));
    this.videoTarget.play();
  }

  hidePoster() {
    this.posterTarget.classList.add("opacity-0");
  }
}
